// extracted by mini-css-extract-plugin
module.exports = {"label":"MultiTextInput_keto_label__3AIH9","input":"MultiTextInput_keto_input__1iJjy"};